const {ESLMediaQuery} = require('@exadel/esl/modules/esl-media-query/core');
const {AmpersandView, template: _template } = require('catalog/libs');

// Template: Navigation Arrows
var templateNav = require('./templates/hpe.product.gallery.template.nav.tpl');

// Template: Thumbnails
var templateThumbnails = require('./templates/hpe.product.gallery.template.thumbnails.tpl');

var ProductGalleryView = AmpersandView.extend({
    initialize() {
        // Cached DOM Elements
        this.elSliderWrapper = this.el.querySelector('.slider-wrapper');

        // Slider: Initialize
        this.sliderInit(this.elSliderWrapper);
    },

    /**
    * It creates Slider Behaviour
    */
    sliderInit(domElement) {
        // Slider: Thumbnails (Template & Data)
        var thumbnails = this.sliderGetThumbnailsList();
        var tpl = _template(templateThumbnails);

        // Slider: Build & Append Navigation Arrows
        this.sliderBuildNav( this.elSliderWrapper );

        /**
        * Slider: Initialize Library
        */
        var Slider = new Sly(
            domElement, {
                easing: 'swing',
                elasticBounds: true,
                horizontal: true,
                itemNav: 'centered',
                mouseDragging: true,
                releaseSwing: false,
                smart: true,
                speed: 300,
                startAt: 0,
                touchDragging: true,
                scrollBy: 1,
                activateOn: 'click',
                activatePageOn: 'click',

                // Arrow Buttons
                prev: this.el.querySelector('.nav-previous'),
                next: this.el.querySelector('.nav-next'),

                // Thumbnails Wrapper (Pager)
                pagesBar: this.el.querySelector('.gallery-thumbnails'),

                // Page item Generator
                pageBuilder: function (index) {
                    return tpl({
                        'picture': thumbnails[index].picture,
                        'orientation': thumbnails[index].orientation,
                        'itemType': thumbnails[index].itemType
                    });
                }
            }
        ).init();

        /**
        * Slider: Event triggered on end of every animation or dragging.
        */
        Slider.on('moveEnd', function () {
            // Update the index position of active item.
            // When using page navigation the active item is not updated properly.
            this.activate(this.rel.activePage);
        });

        /**
        * For web accessibility. Thumbnails are wrapped in anchor tag to allow for tabbing.
        * This prevents the tag from triggering the hash link.
        */
        var thumbAnchors = document.querySelectorAll('.thumb-anchor');
        var i = 0;
        for (i; i < thumbAnchors.length; i++) {
            thumbAnchors[i].addEventListener('click', function (event) {
                event.preventDefault();
            });
        }

        ESLMediaQuery.for('(max-width: 767px)').addEventListener((e) => {
            if (e.matches) Slider.reload();
        });
    },

    /**
    * It Creates Navigation Arrows to control the Slider,
    * then appends the Navigation HTML to the DOM
    *
    * @param {domElement}. HTML Element where the NAV will be appended
    */
    sliderBuildNav(domElement) {
        var i18n = {
            labelPrevious: this.el.getAttribute('data-i18n-label-previous'),
            labelNext: this.el.getAttribute('data-i18n-label-next')
        };

        var tpl = _template(templateNav);

        var navWrapper = document.createElement('div');
            navWrapper.innerHTML = tpl(i18n);
            navWrapper.className = 'gallery-nav';

        // return navWrapper;

        return domElement.appendChild(navWrapper);
    },

    /**
    * It Creates an Array of Objects with data associated to the gallery thumbnails
    *
    * @return Array
    */
    sliderGetThumbnailsList() {
        const items = [...this.el.querySelectorAll('.gallery-item')];
        return items.map((item) => ({
            'picture': item.getAttribute('data-gallery-thumbnail'),
            'orientation': item.getAttribute('data-gallery-orientation'),
            'itemType': item.getAttribute('data-gallery-type')
        }));
    }
});

module.exports = ProductGalleryView;
